import { IPostcodeHook } from '@models';
import { useStore } from '@stores';
import { debounce } from 'lodash';
import { useCallback } from 'react';

export const usePostcodeSearch = (): IPostcodeHook => {
  const { addressStore } = useStore();
  const { postcodes, loadingPostcodes, clearPostcodes } = addressStore;

  const fetchPostcodes = async (query: string) => {
    if (!query || query.length < 2) {
      addressStore.clearPostcodes();
      return;
    }

    await addressStore.getPostcodes(query);
  };

  const debouncedSearch = useCallback(debounce(fetchPostcodes, 300), []);

  return { loading: loadingPostcodes, postcodes, onSearch: debouncedSearch, clearPostcodes };
};
